import {SpecialRequest} from '../../special-request/special-request.model';

export class Warranty {
  id: number;
  warrantyNumber: string;
  warrantyStatus: string;
  isExtended = false;
  invoiced: boolean;
  used = false;
  vehicle: VehicleDetails = null;
  owner: CustomerDetails = null;
  user: CustomerDetails = null;
  keeper: CustomerDetails = null;
  contract: Contract = null;
  maxStep = 0;
  createdBy: string;
  dealerNumber: string;
  specialRequest: SpecialRequest;
  specialRequestRequested: boolean;
  euroPlus07CGOr07CHFound: boolean;
  euroPlusContractStartDateEnteredManually: Date;
  euroPlusContractEndDateEnteredManually: Date;
  sentToNwsDate: Date;
  euroPlusContractTypeEnteredManually: string;
  adminNotes: string;
  dateCreated: string = this.getDateString();
  manufacturersWarrantyStartDate: string;

  getDateString() {
    const local = new Date();
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }

  editable(admin: boolean = false): boolean {
    return !this.warrantyStatus || this.warrantyStatus === 'In Progress' || (!this.specialRequestRequested && this.warrantyStatus === 'Accepted')
      || admin && this.warrantyStatus === 'In Review' || admin && this.specialRequestRequested && this.warrantyStatus === 'Accepted' ||
      admin && this.contract.contractType === 'MINI NEXT YUC' && this.warrantyStatus === 'Accepted';
  }
}

export class Contract {
  // Warranty
  used: boolean;
  initialPremium: number;
  penaltyOrDiscount: number;
  promotionDiscount: number;
  discountOrSurchargeAmount: number;
  amountToBeCharged: number;
  orderDate: string = this.getDateString();
  contractType: string = null;
  contractCode: string = null;
  contractDuration: string;
  contractDurationId: number = null;
  deliveryDate: string = this.getDateString();
  deliveryDateCorrect = false;
  deliveryMileage: number;
  deliveryMileageCorrect = false;
  oilChangeQuestion: string;
  oilChangesTimely = false;
  passed360Question: string;
  passed360 = false;
  deliveryLocation: string;
  requestingDealer: string;
  deliveryDealer: string;
  salePrice: number;
  contractStartDate: string;
  contractEndDate: string;
  contractRate: number;
  acceptNo = false;
  acceptYes = false;
  discountAmount: number;

  getDateString() {
    const local = new Date();
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
  }
}

export class VehicleDetails {
  id: number;
  vin = '';
  licencePlate: string;
  isFirstRegistrationDateFromSource: boolean;
  isLicencePlateDateFromSource: boolean;
  brand: string;
  model: string;
  modelDescription: string;
  dateOfRegistration: string;
  colour: string;
  power: string;
  cubicCapacity: string;
  mileage: number;
  salesPrice: number;
  mileageDate: string;
}

export class CustomerDetails {
  id: number;
  company: string;
  initials: string;
  firstName: string;
  lastName: string;
  street: string;
  streetNumber: string;
  postCode: string;
  city: string;
  telephone: string;
  email: string;
  middleName?: string;
  dateOfBirth?: Date;
  gender?: string;
}
